import { CHARACTERS, ELEMENTS } from "../util/constants/cards";

export const startNewCardRandomizer = function(interval, self) {

    let randomInterval = setInterval(() => {

        let strength = Math.floor(Math.random() * (99 - 0 + 1)) + 0;
        let speed = Math.floor(Math.random() * (99 - 0 + 1)) + 0;
        let stamina = Math.floor(Math.random() * (99 - 0 + 1)) + 0;
        let defense = Math.floor(Math.random() * (99 - 0 + 1)) + 0;
        let character = Math.floor(Math.random() * (99 - 0 + 1)) + 0;
        let element = Math.floor(Math.random() * (9 - 0 + 1)) + 0;

        self.mockCardZero = {
            strength: strength,
            speed: speed,
            stamina: stamina,
            defense: defense,
            level: 1,
            name: CHARACTERS[character].split('_').join(' '),
            element: ELEMENTS[element],
            dna: 'new_gen-0',
            imgUrl: "/static/card_" + CHARACTERS[character] + ".png"
        };

        self.type = '';   

    }, interval);

    return randomInterval;
};

export const stopNewCardRandomizer = function(randomInterval, card, self) {
    clearInterval(randomInterval);
    
    self.mockCardZero = card;
    self.type = "";

    self.$notify({
        group: "app",
        title: "Congratulations!",
        text: "You have created a new card!"
    });
};

export const resetNewCardRandomizer = function(randomInterval, self) {
    clearInterval(randomInterval);

    self.mockCardZero = {};
    self.type = "new";

    self.$notify({
        group: "app",
        title: "Sorry!",
        text: "There was a problem with your transaction!"
    });
};


// WEBPACK FOOTER //
// ./src/util/newCardLogic.js